<template>
    <b-container class="bv-example-row">
        <alert :message="message" />
        <b-row>
            <b-col md="12">
                <h3>List of OTF Assets</h3>
            </b-col>
        </b-row>

        <div class="overflow-auto">

            <b-form-group label="Filter by name" label-for="filter-input" label-cols-sm="2" label-size="sm">
                <b-input-group size="sm">
                    <b-form-input id="filter-input" v-model="filter_by_name" type="search" placeholder="Type to Search"
                        v-on:keyup.enter="download_list_of_otf_assets"></b-form-input>

                </b-input-group>
            </b-form-group>

            <b-form-group label="Filter by uuid" label-for="filter-input" label-cols-sm="2" label-size="sm">
                <b-input-group size="sm">
                    <b-form-input id="filter-input" v-model="filter_by_uuid" type="search" placeholder="Type to Search"
                        v-on:keyup.enter="download_list_of_otf_assets"></b-form-input>

                </b-input-group>
            </b-form-group>

            <b-form-group label="Filter by description" label-for="filter-input" label-cols-sm="2" label-size="sm">
                <b-input-group size="sm">
                    <b-form-input id="filter-input" v-model="filter_by_description" type="search"
                        placeholder="Type to Search" v-on:keyup.enter="download_list_of_otf_assets"></b-form-input>

                </b-input-group>
            </b-form-group>

            <b-form-group label="Filter by space affinity" label-for="dropdownlist" label-cols-sm="2" label-size="sm">
                <b-input-group size="sm">
                    <ejs-dropdownlist id='dropdownlist' placeholder='Start typing the name of the space'
                        :allowFiltering='true' :filtering="filtering" :dataSource='spaces' :fields='space_select_fields'
                        v-model='spaceAffinity'>
                    </ejs-dropdownlist>

                </b-input-group>
            </b-form-group>

            <b-button @click="download_list_of_otf_assets" variant="primary" class="mb-3">Filter</b-button>
            <b-button class="ml-1 mb-3" variant="success" v-b-modal.modalPopover>New OTF Asset</b-button>
            <b-button class="ml-1 mb-3" variant="warning" @click="clear_filters">Clear filter</b-button>
            <b-table id="my-table" :items="projects" :per-page="perPage" :current-page="currentPage" :fields="fields"
                small striped fixed>
                <template v-slot:cell(name)="data">
                    <div class="w-100 text-truncate overflow-hidden">
                        <router-link :to="'/otf_asset/' + data.item.uuid">{{ data.value }}</router-link>
                    </div>
                </template>
                <template v-slot:cell(unlisted)="data">
                    <label v-if="data.value">&#9989;</label>
                    <label v-else>&#10060;</label>
                </template>
                <template v-slot:cell(description)="data">
                    <label v-if="data.value.length > 40">{{ data.value.slice(0, 40) }}...</label>
                    <label v-else>{{ data.value }}</label>
                </template>
            </b-table>

            <b-pagination v-model="currentPage" :total-rows="this.totalRows" :per-page="perPage" align="fill" size="sm"
                class="my-0"></b-pagination>
        </div>

        <b-modal id="modalPopover" title="New OTF Asset generation" @ok="handleOk">

            <form ref="form" @submit.stop.prevent="createNewOtfAsset">
                <b-form-group label="OTF Asset name" label-for="new-otf-asset-name" label-cols-sm="6" label-size="sm"
                    class="mb-0">
                    <b-input-group size="sm">
                        <b-form-input id="new-otf-asset-name" v-model="newOtfAssetName"
                            v-on:keyup.enter="createNewOtfAsset" required></b-form-input>

                    </b-input-group>
                </b-form-group>
            </form>

        </b-modal>
    </b-container>

</template>

<script>
import Alert from '../components/alert.vue';

export default {
    data() {
        return {
            message: '',
            perPage: 20,
            currentPage: 1,
            totalRows: null,
            projects: [],
            filter_by_name: null,
            filter_by_uuid: null,
            filter_by_description: null,
            spaces: null,
            spaceAffinity: null,
            fields: [
                { key: 'name', class: 'text-center align-middle' },
                { key: 'uuid', label: 'UUID', class: 'text-center align-middle' },
                { key: 'description', label: 'Description', class: 'text-center align-middle' },
                { key: 'unlisted', label: 'Unlisted', class: 'text-center align-middle', thStyle: { width: "10%" } },
            ],
            space_select_fields: { text: "name", value: "uuid" },
            newOtfAssetName: null
        }
    },
    components: {
        alert: Alert,
    },
    methods: {
        filtering(e) {
            if (e.text.length >= 3) {
                this.download_spaces(e.text)
            }
        },
        init() {
            this.download_list_of_otf_assets()
        },
        clear_filters() {
            this.filter_by_name = null
            this.filter_by_uuid = null
            this.filter_by_description = null
            this.spaceAffinity = null
        },
        download_list_of_otf_assets() {
            this.$http.get(this.$apiURL + '/otf_assets',
                {
                    headers: this.$store.getters.authHeader,
                    params: { name: this.filter_by_name, uuid: this.filter_by_uuid, space_affinity: this.spaceAffinity, description: this.filter_by_description }
                })
                .then((res) => {
                    this.projects = res.data
                    this.totalRows = this.projects.length
                })
                .catch((error) => {
                    this.message = {
                        'message': error,
                        'type': "danger"
                    }
                });
        },
        handleOk(bvModalEvent) {
            // Prevent modal from closing
            bvModalEvent.preventDefault()
            // Trigger submit handler
            this.createNewOtfAsset()
        },
        createNewOtfAsset() {
            this.$http.post(this.$apiURL + '/admin/otf_asset',
                { name: this.newOtfAssetName },
                { headers: this.$store.getters.authHeader })
                .then((res) => {
                    this.$router.push({ name: "otf_asset", params: { uuid: res.data.uuid } })
                })
                .catch((error) => {
                    this.message = {
                        'message': error.response.data,
                        'type': "danger"
                    }
                });

            this.newOtfAssetName = null;
            this.$nextTick(() => {
                this.$bvModal.hide('modalPopover')
            })
        },
        download_spaces(filter) {
            this.$http.get(this.$apiURL + '/spaces/search',
                {
                    headers: this.$store.getters.authHeader,
                    params: { name: filter }
                })
                .then((res) => {
                    this.spaces = res.data.items
                })
                .catch((error) => {
                    this.message = {
                        'message': error,
                        'type': "danger"
                    }
                });
        }
    },
    created() {
        this.init();
    },
}
</script>
